import { clerkForm } from './clerk-form.js';

clerkForm('sign-up', 'sign-up');
